import { render, staticRenderFns } from "./Accreditation.vue?vue&type=template&id=b0277c02&scoped=true&"
import script from "./Accreditation.vue?vue&type=script&lang=js&"
export * from "./Accreditation.vue?vue&type=script&lang=js&"
import style0 from "./Accreditation.vue?vue&type=style&index=0&id=b0277c02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0277c02",
  null
  
)

export default component.exports